import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { supabase } from './supabase';
import { 
  FiAlertCircle, 
  FiCheckCircle, 
  FiEye, 
  FiEyeOff, 
  FiSave,
  FiArrowLeft
} from 'react-icons/fi';
import './auth-pages.css';

function NewPasswordPage() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const { hasReauthenticated } = useAuth();

  // Redirect if the user hasn't reauthenticated
  useEffect(() => {
    if (!hasReauthenticated) {
      navigate('/dashboard/reauthenticate');
    }
  }, [hasReauthenticated, navigate]);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const changePassword = async () => {
    // Reset messages
    setError('');
    setSuccess('');
    
    // Validate password
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters long.");
      return;
    }

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    try {
      // Update password with Supabase
      const { error } = await supabase.auth.updateUser({
        password: newPassword
      });
      
      if (error) throw error;
      
      setSuccess('Password updated successfully!');
      setTimeout(() => {
        navigate('/dashboard/profile');
      }, 2000);
    } catch (error) {
      setError("Failed to update password: " + error.message);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Change Password</h1>
          <p>Create a new secure password</p>
        </div>

        {error && (
          <div className="auth-error">
            <FiAlertCircle />
            <span>{error}</span>
          </div>
        )}

        {success && (
          <div className="auth-success">
            <FiCheckCircle />
            <span>{success}</span>
          </div>
        )}

        <form className="auth-form">
          <div className="form-group">
            <div className="input-wrapper">
              <input
                type={showPassword ? "text" : "password"}
                className="form-control"
                placeholder="New Password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="auth-btn link-btn" 
                onClick={togglePasswordVisibility}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          <div className="form-group">
            <div className="input-wrapper">
              <input
                type={showConfirmPassword ? "text" : "password"}
                className="form-control"
                placeholder="Confirm New Password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
              />
              <button 
                type="button" 
                className="auth-btn link-btn" 
                onClick={toggleConfirmPasswordVisibility}
                style={{ position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)' }}
              >
                {showConfirmPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          <button type="button" className="auth-btn primary-btn" onClick={changePassword}>
            <FiSave /> Update Password
          </button>
          
          <button type="button" className="auth-btn secondary-btn" onClick={() => navigate('/dashboard/profile')}>
            <FiArrowLeft /> Back to Profile
          </button>
        </form>
      </div>
    </div>
  );
}

export default NewPasswordPage;